import React, {Component} from 'react';
import Graph from "../../../../etc/Graph";
import * as func from "../../../../../utils/functions";
import RederItem from "./9_item";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import {BASE_PATH} from "../../../../../wpconfig";

class Rreferences extends Component {
	constructor(props) {
		super(props);

		// console.log(this.props.record)
		this.state = {
			isInit: false,
			param: {
				// "not_resource_id": this.props.record.resource_id,
				// "journal_id": [this.props.record.journal_id],
				// "my_library": true,
				'order_by': 'date',
				'order': 'desc',
				'record_per_page': 10,
				'current_page': 1
			},
			records: [],
			totalRecords: 0,
			totalPage: 0,
			action : "resource/" + this.props.record.resource_id + '/resource_reference'
		}

		const param = this.state.param;
		func.getData(this.state.action, param).then((response) => {
			this.setState({isInit: true, 'records': response.records, totalRecords : response.pageInfo.totalResults, totalPage :response.pageInfo.totalPage})
		});
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param['current_page'] = paged;

		func.getData(this.state.action, param).then((response) => {
			this.setState({isInit: true, 'records': response.records, totalRecords : response.pageInfo.totalResults, totalPage :response.pageInfo.totalPage})
		});
	}

	render() {
		if (!this.state.isInit || this.state.totalRecords <= 0)
			return ''
		const records = this.state.records;
		return (
			<div className="mt-6">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">참고문헌 ({func.getNumberFormat(this.state.totalRecords)})</h3>
					</div>
				</div>
				<div>
					<table className="table table-lightgray">
						<colgroup>
							<col width="10%"/>
							<col width="auto"/>
						</colgroup>
						<thead>
						<tr>
							<th scope="col" className="">No.</th>
							<th scope="col" className="text-left">참고문헌 정보</th>
						</tr>
						</thead>
						<tbody>
						{records.map((record, index) => {
							const no = this.state.totalRecords - ((this.state.param.current_page - 1) * this.state.param.record_per_page) - index;
							return (
								<RederItem key={index} no={no} record={record}/>
							)
						})}
						{records.length <= 0 &&
							<tr><td className="text-left" colSpan={2}>결과가 없습니다.</td></tr>
						}
						</tbody>
					</table>
				</div>
				{this.state.totalPage > 1 &&
				<div className="mt-4">
					<div>
						<div className="paging-wrap">
							<ReactPaginate
								forcePage={Number(this.state.param.current_page) - 1}
								pageCount={this.state.totalPage}
								marginPagesDisplayed={2}
								pageRangeDisplayed={10}
								onPageChange={this.handlePageClick}
								containerClassName={'pagination'}
								activeClassName={'active'}
								pageClassName={'page-item'}
								pageLinkClassName={'page-link'}
								previousClassName={'page-item page-item-prev'}
								previousLinkClassName={'page-link'}
								nextClassName={'page-item page-item-next'}
								nextLinkClassName={'page-link'}
							/>
						</div>
					</div>
				</div>
				}
			</div>
		);
	}
};

export default Rreferences;
